import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { resolveMediaSources } from "../MediaGallery/lib/resolve-media-sources";
import styles from "./styles/carousel.module.css";

// import Swiper core and required modules
import SwiperCore, { Navigation } from "swiper";

// install Swiper modules
SwiperCore.use([Navigation]);

const XL_BREAKPOINT = 1280;
export function Carousel({ images, changeProduct, isMobile, width, currentProductGroupID }) {
  if (images.length === 0) {
    return null;
  }

  if (images.length === 1) {
    return (
      <div className={styles.imagesSingle}>
        <div className={styles.single}>
          {resolveMediaSources(images[0].flatShot, images[0].productGroup.title, 0)}
        </div>
        {width >= XL_BREAKPOINT && (
          <div className={styles.single}>
            {resolveMediaSources(images[0].firstImage, images[0].productGroup.title, 0)}
          </div>
        )}
      </div>
    );
  }
  const initialSlide = images.findIndex(
    (mediaSrc) => mediaSrc.productGroup._id === currentProductGroupID
  );

  if (isMobile || width < XL_BREAKPOINT) {
    return (
      <Swiper
        cssMode={true}
        slidesPerView={1}
        onSlideChange={(swiper) => {
          if (images[swiper.realIndex].productGroup._id !== currentProductGroupID) {
            changeProduct(images[swiper.realIndex].productGroup);
          }
        }}
        initialSlide={initialSlide === -1 ? 0 : initialSlide}
        navigation={true}
        loop={true}
        className={styles.carousel}
      >
        {images.map((mediaSrc, index) => {
          return (
            <SwiperSlide key={index}>
              <div className={styles.images}>
                <div className={styles.active}>
                  {resolveMediaSources(mediaSrc.flatShot, mediaSrc.productGroup.title, index)}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    );
  }

  return (
    <Swiper
      loop={true}
      slidesPerView={3}
      slidesPerGroup={1}
      centeredSlides={true}
      onSlideChange={(swiper) => {
        if (images[swiper.realIndex].productGroup._id !== currentProductGroupID) {
          changeProduct(images[swiper.realIndex].productGroup);
        }
      }}
      initialSlide={initialSlide === -1 ? 0 : initialSlide}
      navigation={true}
      className={styles.carousel}
    >
      {images.map((mediaSrc, index) => {
        return (
          <SwiperSlide key={index}>
            {({ isActive }) => (
              <div className={styles.images}>
                <div className={isActive ? styles.active : styles.notActive}>
                  {resolveMediaSources(mediaSrc.flatShot, mediaSrc.productGroup.title, index)}
                </div>
              </div>
            )}
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}

Carousel.propTypes = {
  images: PropTypes.array.isRequired,
  changeProduct: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  width: PropTypes.number.isRequired,
  currentProductGroupID: PropTypes.string.isRequired,
};
